import { useHMSRaiseHand } from "../hms";
import { useLivekitRaiseHand } from "../livekit";
import type { ProviderRaiseHand } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderRaiseHand = (peerId?: string): ProviderRaiseHand =>
  useProviderHook({
    hms: useHMSRaiseHand,
    livekit: useLivekitRaiseHand,
  })(peerId);
